import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import "rxjs/add/operator/map";
import "rxjs/add/operator/toPromise";
import "rxjs/add/operator/catch";
import * as globalConst from "../../../../../../constants";

@Injectable()
export class GcMultiselectService {
private apiUrl = globalConst.baseAPI;

constructor(private http: Http) { }

getGC(token) {
    return this.http
      .get(this.apiUrl + "commercialstructure/v1/getcommercialstructurebypapel/G?$filter=Ativo eq true&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .toPromise()
      .then((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

getGCPadrao() {
    return this.http
      .get(this.apiUrl + "commercialstructure/v1/getcommercialstructurebypapel/G?$filter=Ativo eq true&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/cockpit/component/cockpit/gc-multiselect/service/gc-multiselect.service.ts